// Supported file extensions and their MIME types for file browser filtering
export const SUPPORTED_MIME_TYPES = {
  // Images
  'png': 'image/png',
  'jpg': 'image/jpeg',
  'jpeg': 'image/jpeg',
  'gif': 'image/gif',
  'webp': 'image/webp',

  // Document formats
  'pdf': 'application/pdf',
  
  // Programming languages
  'js': 'text/javascript',
  'py': 'text/x-python',
  
  // Web formats
  'html': 'text/html',
  'htm': 'text/html',
  'css': 'text/css',
  
  // Text formats
  'txt': 'text/plain',
  'md': 'text/md',
  'csv': 'text/csv',
  'xml': 'text/xml',
  'rtf': 'text/rtf',
  
  // Special case: JSON files are treated as plain text
  'json': 'text/plain',
  
  // Audio
  'wav': 'audio/wav',
  'mp3': 'audio/mp3',
  'mpeg': 'audio/mpeg',
  
  // Video
  'mp4': 'video/mp4',
  'mpg': 'video/mpeg',
  'mov': 'video/mov',
  'avi': 'video/avi',
  'flv': 'video/x-flv',
  'wmv': 'video/wmv',
} as const;

export const SUPPORTED_EXTENSIONS = Object.keys(SUPPORTED_MIME_TYPES);

/**
 * Check if a file extension is supported
 */
export function isSupportedExtension(extension: string): boolean {
  return SUPPORTED_EXTENSIONS.includes(extension.toLowerCase());
}

/**
 * Get file extension from filename
 */
export function getFileExtension(filename: string): string {
  const lastDotIndex = filename.lastIndexOf('.');
  if (lastDotIndex === -1 || lastDotIndex === filename.length - 1) {
    return '';
  }
  return filename.slice(lastDotIndex + 1).toLowerCase();
}

/**
 * Check if a filename has a supported extension
 */
export function isSupportedFile(filename: string): boolean {
  const extension = getFileExtension(filename);
  return isSupportedExtension(extension);
}

/**
 * Get MIME type for a supported file extension
 */
export function getMimeTypeForExtension(extension: string): string | undefined {
  return SUPPORTED_MIME_TYPES[extension.toLowerCase() as keyof typeof SUPPORTED_MIME_TYPES];
}